'use client'

import Link from 'next/link';
import { usePathname, useRouter } from 'next/navigation';
import { ArrowUpRight } from 'lucide-react';


export function Navigation() {
  const pathname = usePathname()
  const router = useRouter()
  
  console.log('Navigation - Current pathname:', pathname);
  
  const navItems = [
    { name: 'About', href: '/', external: false },
    { name: 'Blog', href: '/blog', external: false },
    { name: 'Projects', href: '/projects', external: false },
    { name: 'LinkedIn', href: 'https://www.linkedin.com/in/elvan-konukseven', external: true },
    { name: 'GitHub', href: 'https://github.com/elvankonukseven', external: true }
  ];

  return (
    <nav className="flex flex-col space-y-3 text-base">
      {navItems.map((item) => {
        // Very simple logic: exact match for home, startsWith for others
        let isActive = false;
        if (item.href === '/') {
          isActive = pathname === '/';
        } else {
          isActive = pathname.startsWith(item.href);
        }

        console.log(`Navigation - ${item.name}:`, {
          href: item.href,
          pathname: pathname,
          isActive: isActive
        });

        if (item.external) {
          return (
            <a
              key={item.name}
              href={item.href}
              target="_blank"
              rel="noopener noreferrer"
              className='text-pink-500 hover:text-pink-700 dark:text-gray-400 hover:dark:text-gray-300 dark:underline dark:underline-offset-2 dark:decoration-gray-800 inline-flex items-center'
            >
              {item.name}
              <ArrowUpRight className="inline w-4 h-4 ml-1" />
            </a>
          );
        }

        return (
          <Link
            key={item.name}
            href={item.href}
            className='text-gray-600 hover:text-pink-500 font-normal'
          >
            <div className={`${isActive ? "font-bold text-black" : ""}`}>
              {item.name}
            </div>
          </Link>
        )
      })}
    </nav>
  );
} 